import { Capacitor } from '@capacitor/core';
import { IonIcon } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import { useLongPress } from '../../../../../hooks/useLongPress';

export const PHOTO_TILE_SIZE = 72;

interface PostPhotoThumbProps {
  url: string;
  onDelete: () => void;
}

/**
 * Square, cropped thumbnail of a post photo in the editor. Deleting it is a small
 * ✕ button on the web and a long press on native apps.
 */
export const PostPhotoThumb = ({ url, onDelete }: PostPhotoThumbProps) => {
  const isNative = Capacitor.isNativePlatform();
  const longPress = useLongPress(onDelete, { enabled: isNative });

  return (
    <div
      className="relative shrink-0 select-none"
      style={{ width: PHOTO_TILE_SIZE, height: PHOTO_TILE_SIZE, WebkitTouchCallout: 'none' }}
      data-testid="post-photo-thumb"
      {...longPress}
    >
      <img
        src={url}
        alt="Foto de la publicación"
        className="h-full w-full object-cover"
        style={{ borderRadius: '8px' }}
        draggable={false}
      />
      {!isNative && (
        <button
          type="button"
          className="absolute right-1 top-1 flex h-6 w-6 items-center justify-center bg-black/60 text-white cursor-pointer"
          style={{ borderRadius: '9999px', padding: 0 }}
          onClick={onDelete}
          aria-label="Eliminar foto"
        >
          <IonIcon icon={closeOutline} aria-hidden="true" />
        </button>
      )}
    </div>
  );
};
